import { Input, Modal } from "antd";
import { isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "shared/components/Button";
import { NAME_SPACES } from "shared/locales/constants";

const RenameModal = ({ name, onClose, onRename }) => {
  const { t } = useTranslation(
    NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS_EDITOR,
  );
  const RENAME = t("RENAME", { returnObjects: true });
  const [value, setValue] = useState(name);
  const trimmed = value.trim();

  const confirm = () => {
    if (isEmpty(trimmed)) return;
    onRename(trimmed);
  };

  return (
    <Modal
      open
      centered
      title={RENAME.TITLE}
      onCancel={onClose}
      footer={
        <div className="dynamic-documents-editor__sheet-footer">
          <Button type="gray--link" onClick={onClose}>
            {RENAME.CANCEL}
          </Button>
          <Button type="primary" disabled={isEmpty(trimmed)} onClick={confirm}>
            {RENAME.CONFIRM}
          </Button>
        </div>
      }
    >
      <div className="dynamic-documents__config-field-label">
        {RENAME.LABEL}
      </div>
      <Input
        autoFocus
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onPressEnter={confirm}
      />
    </Modal>
  );
};

export default RenameModal;
